<div class="container">
  <div class="actions">
    <button (click)="addVehicle()" class="btn-action">
      <fa-icon [icon]="['fas', 'square-plus']" class="fa-thin"></fa-icon>
      Add Vehicle</button>
    <button (click)="bulkUpload()" class="btn-action">
      <fa-icon [icon]="['fas', 'upload']" class="fa-solid"></fa-icon>
      Bulk Upload</button>
      <button
              type="button"
              class="btn-icon-action"
              (click)="downloadTemplate()"
              title="Download Vehicle Import Template">
          <fa-icon [icon]="['fas', 'file-excel']"></fa-icon>
      </button>
  </div>
  
  <div class="container-table">
    <header class="top-header">
     <h3>Vehicle Records</h3>
      <p>Vehicle Details As On {{todayDate | date: "dd-MM-yyyy" }}</p>
    </header>
    <!-- <div class="card-top card-head">
      <h4>Vehicle Records</h4>
      <p>Vehicle Details As On {{todayDate | date: "dd-MM-yyyy" }}</p>
    </div> -->
    <!-- <header class="top-header">
      <h3>Profile Info</h3>
    </header> -->
    <div>
      <div class="tab-head">
        <div class="search-bar wide-search-bar">
            <!-- <input name='searchText' type="text" [ngModel]="searchText" placeholder="Search" (click)="vehicleSearch()"> -->
            <!-- <form (ngSubmit)="vehicleSearch()" autocomplete="off" class="search-form"> -->
              <!-- <div class="search-input-wrapper" #searchWrapper>
                <input type="text"
                  [(ngModel)]="searchText"
                  name="searchText"
                  id="searchText"
                  placeholder="Search..."
                  (input)="onSearch(searchText)"
                  class="search-input"
                >
                <div *ngIf="showNoMatchTooltip" class="suggestions-dropdown no-match-tooltip">
                  <fa-icon
                  [icon]="['fas', 'circle-info']"
                  ></fa-icon>
                  <span>Press Enter to search</span>
                </div>
                
                
                <div *ngIf="suggestions && suggestions.length && searchText" class="suggestions-dropdown">
                  <div *ngFor="let suggestion of suggestions | slice:0:4"
                       (click)="onSuggestionClick(suggestion)"
                       class="suggestion-item">
                    <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon>
                    <div class="suggestion-text">
                      <span class="suggestion-main">{{ formatSuggestionContext(splitSuggestion(suggestion).main) }}</span>
                      <span *ngIf="splitSuggestion(suggestion).context" class="suggestion-context">
                        {{ splitSuggestion(suggestion).context }}
                      </span>
                    </div>
                  </div>
                  <div *ngIf="suggestions.length === 0" class="no-suggestions">No results found</div>
                </div>
              </div> -->
              <!-- <app-search-suggestion
                  [placeholder]="'Search...'"
                  [apiFn]="apiService.getVehicleDBSearchSuggestions.bind(apiService)"
                  [suggestionKey]="'search_keys'"
                  [searchText]="searchText"
                  [searchElement]="vehicleSearch.bind(this)">
              </app-search-suggestion> -->
              <!-- <app-generic-search
                [apiUrl]="'vehicles/search_suggestion'"
                [method]="'GET'"
                [queryParamName]="'q'"
                [minChars]="2"
               
                (searchSelected)="onSearchResults($event)">
              </app-generic-search> -->
              <app-generic-search
              [apiUrl]="'vehicles/search_suggestion'"
              [resultsApiUrl]="'vehicles/'"
              [method]="'GET'"
              [searchParamName]="'q'"
              [pageSize]="10"
              [minChars]="2"
              (resultsFetched)="onResults($event)">
            </app-generic-search>



            <!-- </form> -->
        </div>
        <button (click)="exportToExcel()" class="export-button">
          <fa-icon [icon]="['fas', 'file-excel']" class="fa-thin" style="color: white;font-size: 15px;"></fa-icon>
          EXPORT EXCEL
        </button>
      </div>
      <div class="responsive-table-wrapper">
        <table>
          <thead>
              <tr>
              <th>S.No</th>
              <th>EmpId</th>
              <th>Vehicle No</th>
              <th>Person Name</th>
              <th>Added By</th>
              <th>Created On</th>
              <th>Action Items</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let record of vehicleDatabase let i = index ">
                <td>{{ i + 1 + (currentPage - 1) * recordsPerPage }}</td> <!-- 10 -> pagesize -->
                <td>{{ record.employee_id }}</td>
                  <td [appVehicleNumberCopy]="record.vehicle_number">{{ record.vehicle_number }}</td>
                <td>{{ record.person_name }}</td>
                <td>{{ record.created_by }}</td>
                <td>{{ record.created_at | date: 'dd-MM-yyyy hh:mm a' }}</td>
                <td>
                  <button class="action-button bt-edit" (click)="updateVehicle(record.id)" title="Edit">
                    <span>
                      <fa-icon [icon]="['fas', 'pen']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                  <button class="action-button bt-blacklist" (click)="openBlacklistConfirmationDialog(record)" title="Add To Blacklist">
                    <span>
                      <fa-icon [icon]="['fas', 'ban']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                    <button class="action-button bt-hotlist" (click)="openHotlistConfirmationDialog(record)"
                            title="Add to Hotlisted Vehicles">
                    <span>
                      <fa-icon [icon]="['fas', 'fire']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                  <button class="action-button bt-delete" (click)="openConfirmationDialog(record.id)" title="Delete">
                    <span>
                      <fa-icon [icon]="['fas', 'trash']" class="fa-light"></fa-icon>
                    </span>
                  </button>
                </td>
              </tr>
          </tbody>
        </table>
      
        <div class="footer">
          <div class="total-records">Total Records: {{ totalRecords }}</div>
          <div class="pagination-controls">
            <label for="recordsPerPage">Records per page </label>
            <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()" >
                <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
            </select>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <!-- <button (click)="changePage(currentPage - 1)" class="change-page" title="Previous page">
              <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
            </button>
            <button (click)="changePage(currentPage + 1)" class="change-page" title="Next page">
              <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
            </button> -->
            <button (click)="previous()" [disabled]="!previousPage" class="change-page" title="Previous page">
              <fa-icon [icon]="['fas', 'angle-left']" class="fa-light"></fa-icon>
            </button>
            <button (click)="next()" [disabled]="!nextPage" class="change-page" title="Next page">
              <fa-icon [icon]="['fas', 'angle-right']" class="fa-light" style="background-color: none;"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Modal Confirmation dialog -->
<div *ngIf="showConfirmationDialog" class="confirmation-modal">
  <div class="modal-content">
    <div class="modal-header">
      <i class="bi bi-exclamation-triangle warning-icon"></i>
      <h3>{{ confirmationTitle }}</h3>
    </div>
    <div class="modal-body">
      <p>{{ confirmationMessage }}</p>
    </div>
    <div class="modal-footer">
      <button (click)="confirmAction()" class="confirm-btn modal-red">Yes, Proceed</button>
      <button (click)="closeConfirmationDialog()" class="cancel-btn cancel-btn-green">Cancel</button>
    </div>
  </div>
</div>